import { Button } from "@mui/material";
import Image from "mui-image";
import React from "react";
import TICK from "../../../assets/images/Check.svg";

export default function StageOneComplete({ step = 0, setStep = () => {} }) {
  return (
    <div
      className="onboarding-step onboarding-step-5"
      style={{ padding: "1rem" }}
    >
      <div
        style={{
          marginTop: "70%",
          transform: "translateY(-50%)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image src={TICK} width={70} height={70} duration={200} />
        </div>
        <p
          style={{
            margin: "20px 0 4px 0",
            fontSize: "24px",
            fontWeight: 600,
            textAlign: "center",
            color: "#CFCFCF",
          }}
        >
          Stage 1 Completed
        </p>
        <p
          style={{
            margin: "0 0 24px 0",
            fontSize: 18,
            lineHeight: 1.4,
            fontWeight: 400,
            color: "#9F9F9F",
            textAlign: "center",
          }}
        >
          Now you can proceed to <br />
          get your health score
        </p>
        <Button
          onClick={() => setStep(step + 1)}
          fullWidth
          variant="contained"
          size="large"
          style={{
            marginBottom: 16,
            padding: "16px 0",
            fontSize: "1em",
            boxShadow: "none",

            background:
              "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color: "#FF4A01",
          }}
        >
          Get health score
        </Button>
        <Button
          onClick={() => setStep(9)}
          fullWidth
          variant="contained"
          // color="secondary"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",
            boxShadow: "none",
            background: "none",

            border: "1.08744px solid #FFFFFF",
          }}
        >
          Skip for now
        </Button>
      </div>
    </div>
  );
}
